<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >

    <!-- // MAINFORM -->
    <b-form id="main">

      <div class="row col-sm-12 mt-2">

          <!-- // MAIN DATAS -->

          <div class="col-sm-2">
            <div class="form-group" hidden>
              <label for="azon">Azonosító</label>
              <b-form-input
                size="sm"
                type="text"
                v-model="azonTemp"
                class="form-control"
                id="azon"
                disabled
              />
            </div>      
              <label for="partner">Státusz</label>
              <b-form-select label="Státusz"  v-model="statusSelect" :options="status" size="sm"  id="status"></b-form-select>     
          </div>

          <div class="col-sm-2">
         
          </div>

          <div class="col-sm-3">
            <div class="form-group" >
              <label for="partner">MiniCRM adatlap neve</label>
              <b-form-input ref="MiniCRM" size="sm" v-model="partner" id="partner" required></b-form-input>              
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="emaillink">MiniCRM adatlap link</label>
              <b-form-input size="sm" v-model="emaillink" id="emaillink" required></b-form-input>              
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="megjegyzes">Megjegyzés</label>
              <textarea v-model="megjegyzes" class="form-control" id="megjegyzes" cols="30" rows="1"></textarea>
            </div>
          </div>
      </div>

    </b-form>

    <!-- // EDITOR SECTION -->
    <div class="row">

      <!-- // ÚJ MUNKALAP -->
      <div v-show="MunkalapShow" class="col-sm-12 mt-3 mx-auto" style="bottom: 20px;">
        <b-card
          header
          border-variant="secondary"
          header-bg-variant="none"
          header-text-variant="white"
          header-border-variant="none"
          footer
          header-class="munkalapcardheader"
        >
          <template#header>
            <em>
              <table style="width:960px;" class="center">
                <tbody>
                  <tr>
                     <td>
                      <b-button
                        size="sm"
                        variant="outline-warning"
                        class="float-left"                        
                        v-b-modal.modal-1
                      ><b-icon-plus-circle></b-icon-plus-circle>
                      Egyéb tételek</b-button>
                    </td>
                    <td>
                      <!-- // SAVE -->
                      <b-button
                        size="sm"
                        variant="success"
                        class="float-right"                        
                        type="submit"
                        @click="saveWork"
                        ><b-icon-cloud-upload></b-icon-cloud-upload>
                        Nyomdai munkalap mentése
                      </b-button>
                    </td>
                    <td>
                      <!-- // CANCEL -->
                      <!-- <b-button
                        size="sm"
                        variant="outline-danger"
                        class="float-right"
                        @click="
                          $router.push({
                            name: 'NyomdaiMunkak'
                          })
                        "
                        ><b-icon-arrow-left></b-icon-arrow-left>
                          Mégsem
                        </b-button> -->
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </em>                             
          </template>   


          <b-form>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Megnevezés" label-for="input-sm">
                <b-form-input v-model="myNyomdaiMunkalapTelels.megnevezes" id="megnevezes" size="sm" required></b-form-input>
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Méret" label-for="input-sm">
                <b-form-select label="Opció" v-model="myNyomdaiMunkalapTelels.meret" :options="meretek" size="sm"  id="opciok"></b-form-select>     
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Terjedelem" label-for="input-sm">
                <b-form-select label="Opció" v-model="myNyomdaiMunkalapTelels.terjedelem" :options="terjedelemek" size="sm"  id="opciok"></b-form-select>     
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Papír" label-for="input-sm">
                <b-form-select label="Opció" v-model="myNyomdaiMunkalapTelels.papir" :options="papirok" size="sm"  id="opciok"></b-form-select>     
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Szín" label-for="input-sm">
                <b-form-select label="Opció" v-model="myNyomdaiMunkalapTelels.szin" :options="szinek" size="sm"  id="opciok"></b-form-select>     
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Kötészet" label-for="input-sm">
                <b-form-select label="Opció" v-model="myNyomdaiMunkalapTelels.koteszet" :options="koteszetek" size="sm"  id="opciok"></b-form-select>     
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Opciók" label-for="input-sm">
                <b-form-input type="text" v-model="myNyomdaiMunkalapTelels.opciok" id="opciok" size="sm" required></b-form-input>
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Egyéb" label-for="input-sm">
                <b-form-input type="text" v-model="myNyomdaiMunkalapTelels.egyeb" id="egyeb" size="sm" required></b-form-input>
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Mennyiség" label-for="input-sm">
                <b-form-input type="number" @keyup="osszegCount" v-model="myNyomdaiMunkalapTelels.mennyiseg" id="menyiseg" size="sm" required></b-form-input>
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Darabár" label-for="input-sm">
                <b-form-input type="number" @keyup="osszegCount" v-model="myNyomdaiMunkalapTelels.darabar" id="darabar" size="sm" required></b-form-input>
            </b-form-group>
            <b-form-group label-align-sm="right" label-cols="3" label-cols-lg="2" label-size="sm" label="Összesen" label-for="input-sm">
                <b-form-input v-model="myNyomdaiMunkalapTelels.osszesen" id="osszesen" size="sm" required disabled=""></b-form-input>
            </b-form-group>
          </b-form>

          <!-- MUNKALAP TABÁLÁZAT -->
          <div class="col-sm-12">

            <!-- // EGYÉB TÉTEL -->
            <div v-if="myCikkTetels " v-show="EgyebTetelekShow">
              <table style="width:960px !important;"  class="table-sm mx-auto mt-1">

                <tbody>
                  <tr v-for="(tetel, index) in myCikkTetels" :key="tetel.id">
                    <th style="width:60px !important;" colspan="1" >
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="$delete(myCikkTetels, index)"
                        class="btnmini mr-1"
                      ><b-icon-trash></b-icon-trash>
                      </b-button>
                    </th>
                    <th style="width:270px !important;"  class="text-left">{{tetel.megnevezes}}</th>
                    <th style="width:50px !important;" >
                      <input type="number" v-model="tetel.db" @keyup="getVegOsszeg1" :key="tetel.id" class="form-control inputmini form-control-sm text-right" id="mennyiseg" required>
                    </th>
                    <th style="width:50px !important;" >{{tetel.mennyisegiegyseg}}</th>
                    <th style="width:50px !important;" ></th>
                    <td style="width:170px !important; font-size:smaller;"  class="text-right darkgray"></td>
                    <th style="width:170px !important; font-size:smaller;"  class="text-right">{{parseFloat(tetel.netto).toFixed(2) * parseFloat(tetel.db).toFixed(2)}}</th>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table">
                    <td colspan="8"></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- // MODAL EGYÉB TÉTEL -->
            <div>
              <b-modal id="modal-1" title="Egyéb tételek" >
                <div class="form-group" >
                  <label for="cikkek">Egyéb tételek hozzáadása</label>
                  <select v-model="cikkSelect" class="form-control" id="cikkek">
                    <option v-for="(cikkek) in cikkek" :key="cikkek.id" :value="cikkek">
                      {{ cikkek.megnevezes }}
                    </option>
                  </select>
                </div>
                <template #modal-footer>
                  <div class="w-100">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="float-right"
                      @click="addCikkTetel"
                    ><b-icon-plus-circle></b-icon-plus-circle>
                      Hozzáadás
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>

          </div>

          <!-- // VÉGÖSSZEG -->
          <!-- <div class="col-sm-6 mx-auto">

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <p :prop="getVegOsszeg">Kalkulált végösszeg: </p>
              </div>
              <div class="col-sm-4 mx-auto">
                <p class="float-left">{{VegOsszeg}}</p>
              </div>
              <div class="col-sm-4 mx-auto">
              </div>
            </div> 

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <h3 :prop="getVegOsszeg">Végösszeg: </h3>
              </div>
              <div class="col-sm-4 mx-auto">
                <input id="vegosszeg1" class="form-control form-control-sm" type="number" v-model="VegSumOsszeg" >
              </div>
              <div class="col-sm-4 mx-auto">
                <b-button
                  size="sm"
                  variant="outline-info"
                  class="float-left"
                  type="submit"
                  @click="getVegOsszeg1"
                ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                Újraszámolás
                </b-button>
              </div>
            </div>   
          </div> -->

            <div>
              <table style="width:960px !important;" class="mx-auto">
              <!-- <table style="width:960px !important;" class=" table-bordered center mr-2"> -->
                <tbody>
                  <tr class="text-right darkgray" style=" font-size:smaller;">
                    <td  :prop="getVegOsszeg" >Számított végösszeg : </td>
                    <td style="padding-right: 10px; ">{{VegOsszeg}}</td>
                  </tr>
                  <tr class="text-right">
                    <td>
                      <h5 :prop="getVegOsszeg">Kiajánlott ár : </h5>
                    </td>
                    <td style="width:100px !important;">
                      <input style="font-weight:bold; height: calc(1em + 0.5rem + 2px);" id="vegosszeg1" class="form-control miniinput form-control-sm text-right" type="number" v-model="VegSumOsszeg" >
                    </td>
                    <!-- <td>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        class="float-left"
                        type="submit"
                        @click="getVegOsszeg1"
                      ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                      Újraszámolás
                      </b-button>                    
                    </td> -->
                  </tr>
                </tbody>
              </table>

            </div>             
            
          <!-- FOOTER     -->
          <!-- <template #footer>
            <em>
              <div class="col-sm-12 mx-auto">
                <div>
                  // SAVE
                  <b-button
                  size="sm"
                    variant="success"
                    class="float-left"
                    type="submit"
                    @click="saveWork"
                    ><b-icon-cloud-upload></b-icon-cloud-upload>
                    Munkalap mentése
                  </b-button>

                  // CANCEL
                  <b-button
                  size="sm"
                    variant="outline-danger"
                    class="float-left ml-1"
                    @click="
                      $router.push({
                        name: 'Munkak'
                      })
                    "
                    ><b-icon-arrow-left></b-icon-arrow-left>
                      Mégsem
                    </b-button>

                </div>
              </div> 
            </em>                             
          </template>               -->

        </b-card>
      </div>
    </div>
  

      <!-- <div class="row">
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
      </div>       -->

  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import router from '../router'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      first_name: decoded.first_name,
      last_name: decoded.last_name,
      monogram: decoded.monogram,
      status: [],
      statusSelect: [],
      statusEditId: 0,
      megjegyzes: '',
      ar: '',
      osszterulet: null,
      azonTemp: '',
      partner: '',
      emaillink: '',
      cikkek: [],
      cikkSelect: [],
      myCikkTetels: [],
      EgyebTetelekShow: false,
      VegosszegShow: false,
      MunkalapShow: true,
      VegOsszeg: 0,
      VegSumOsszeg: 0,
      NettoOssz: null,
      client: {},
      myNyomdaiMunkalapTelels: 
        {
        megnevezes: "",
        meret: "",
        terjedelem: "",
        papir: "",
        szin: "",
        koteszet: "",
        opciok: "",
        egyeb: "",
        mennyiseg: 0 ,
        darabar: 0 ,
        osszesen: 0
        },
      meretek: ["A3", "A4", "A5", "A6", "egyedi méret megjegyzésben", "névjegy 90x50 mm"],
      terjedelemek: ["2 oldal", "4 oldal", "6 oldal", "8 oldal", "10 oldal", "terjedelem megjegyzésben"],
      papirok: ["100g Color Copy" ,"160 g Color Copy" ,"350g Color Copy" ,"350g Claro Gloss" ,"80 g ofszet" ,"papír öntapadó MATT" ,"papír öntapadó Selyemfényű" ,"papír öntapadó FÉNYES" ,"135 g műnyomó" ,"megjegyzésben"],
      szinek: ["1+1 fekete", "1+1 színes", "4+4", "4+1", "4+0", "megjegyzésben"],
      koteszetek: ["vágva", "tűzve", "irka", "ragasztva"]
    }
  },
  methods: {
    osszegCount: function (req, index) {
      console.log('Jó reggelt')
      this.myNyomdaiMunkalapTelels.osszesen = this.myNyomdaiMunkalapTelels.mennyiseg * this.myNyomdaiMunkalapTelels.darabar
      this.getVegOsszeg1()      
      // this.$delete(req, index)
      // this.pageOsszeteruletCount()
    },
    deleteTetel: function (req, index) {
      this.$delete(req, index)
      this.getVegOsszeg1()      
    },
    getVegOsszeg1 () {
      let sumegyeb = 0
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      let result = this.VegSumOsszeg = sumegyeb + this.myNyomdaiMunkalapTelels.osszesen
      return result
    },
    addCikkTetel: function () {
      this.myCikkTetels.push(
        {
          cikkid: this.cikkSelect.id,
          megnevezes: this.cikkSelect.megnevezes,
          mennyisegiegyseg: this.cikkSelect.mennyisegiegyseg,
          db: 0,
          netto: this.cikkSelect.netto,
          nettoosszesen: this.cikkSelect.netto
        }
      )
      this.EgyebTetelekShow = true
      this.VegosszegShow = true
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
    },
    saveWork: function () {
      if (
        this.statusSelect !== '' &&
        this.partner !== ''
      ) {
        let payload = {}
        payload.id = this.$route.params.id
        payload.azonosito = this.azonTemp
        payload.statusid = this.statusSelect.id
        payload.opciok = this.opciok
        payload.egyeb = this.egyeb
        payload.partner = this.partner
        payload.emaillink = this.emaillink
        payload.megjegyzes = this.megjegyzes
        payload.kiallitotta = this.monogram
        payload.szamitottVegOsszeg = this.VegOsszeg
        payload.VegOsszeg = this.VegSumOsszeg
        payload.myNyomdaiMunkalapTelels = this.myNyomdaiMunkalapTelels
        payload.cikkTetels = this.myCikkTetels
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API+'/nyomdaimunkak/save', {payload}).then((res) => {
          console.log(res.data.id)
          this.$router.push({ name: 'NyomdaiMunkakPrint' , params: { id: res.data.id }})
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    focusInput() {
      this.$refs.MiniCRM.focus();
    }
  },
  computed: {
    getVegOsszeg: function () {
      let sumegyeb = 0
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      this.getVegOsszeg1()
      let result = this.VegOsszeg = sumegyeb + this.myNyomdaiMunkalapTelels.osszesen
    } 
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      if(payload.id) {
        axios.post(process.env.ROOT_API+'/nyomdaimunkak/pdf', {payload})
          .then(res => {
            console.log(res.data.client)
            this.emaillink = res.data.client.emaillink
            this.megjegyzes = res.data.client.megjegyzes
            this.partner = res.data.client.partner
            this.partnerkategoriaSelected = res.data.client.partnerkategoria
            this.myCikkTetels = res.data.client.cikkTetels
            this.statusSelect = res.data.client.statusid
            this.VegSumOsszeg = res.data.client.VegOsszeg
            this.monogram = res.datamonogram
            this.myNyomdaiMunkalapTelels.megnevezes = res.data.client.megnevezes
            this.myNyomdaiMunkalapTelels.terjedelem = res.data.client.terjedelem
            this.myNyomdaiMunkalapTelels.papir = res.data.client.papir
            this.myNyomdaiMunkalapTelels.szin = res.data.client.szin
            this.myNyomdaiMunkalapTelels.koteszet = res.data.client.koteszet
            this.myNyomdaiMunkalapTelels.opciok = res.data.client.opciok
            this.myNyomdaiMunkalapTelels.egyeb = res.data.client.egyeb
            this.myNyomdaiMunkalapTelels.mennyiseg = res.data.client.mennyiseg
            this.myNyomdaiMunkalapTelels.darabar = res.data.client.darabar
            this.myNyomdaiMunkalapTelels.osszesen = res.data.client.osszesen
            this.myNyomdaiMunkalapTelels.meret = res.data.client.meret
            this.EgyebTetelekShow = true
          })
          .catch(err => {
            console.log(err)
          })
      }
      axios.post(process.env.ROOT_API+'/utils/getcode')
        .then((res) => {
          this.azonTemp = res.data
        }).catch((err) => {
          console.log(err)
        })
      axios.post(process.env.ROOT_API+'/cikkek/getlist', { payload })
        .then((res) => {
          this.cikkek = res.data
        }).catch((err) => {
          console.log(err)
        })
      axios.post(process.env.ROOT_API+'/status/getlist', { payload })
        .then((res) => {
          for (var el in res.data) {
            this.status.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
          // this.statusSelect = res.data[0]
        }).catch((err) => {
          console.log(err)
        })
      this.getVegOsszeg1()      
      this.focusInput()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NyomdaiMunkakNew.vue